<div style="display: flex; justify-content: center; align-items: center; height: 100vh">
  <p style="color: green; font-size: 48px; font-weight: bold">SUCCESS</p>
</div>
